import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Code', 'Description'];

export const ProjectsDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: projectOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'projectDescription1',
    valueAttribute: 'projectQuotationNumber',
    params: {
      windowId: 'project',
    },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={projectOptions} columnNames={COLUMN_NAMES} />;
};
